import { ref, type Ref } from "vue"

export const messageAlertDisconnectEmptyHappy = {
    message: '',
    class: ''
}

export interface MessageAlertDisconnectHappy {
    message: string;
    class: string;
}

export const messageAlertDisconnectHappy: Ref<MessageAlertDisconnectHappy> = ref(messageAlertDisconnectEmptyHappy)